module.exports = __webpack_public_path__ + "static/media/health-and-safety-authority.4104b96b.png";